import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';

export default [
  {
    name: 'lottie-animation',
    component: LottieAnimation,
  },
];
